<template>
  <div>

    <!-- <Spin fix></Spin> -->
    <Card style="width:100%">

      <div style="border:1px solid #ffd77a; padding: 20px; background:#fff9e6;color:#515a6e;border-radius: 5px;">
        <div style="font-size:16px;color:#17233d;">人才中心调档：</div>
        <div style="font-size:14px;"> 下载调档函后，需要将调档函递交至原档案保管机构。档案应由原档案保管机构通过机要方式转递至人才中心。</div>
        <div style="font-size:16px;color:#17233d;margin-top:20px;">单位自行核档：</div>
        <div style="font-size:14px;"> 请上传单位核档表。</div>
        <div style="font-size:14px;margin-top:20px;"> 配偶需要调档的情况同本人。</div>
        <div style="font-size:14px;margin-top:20px;"> 如有技术问题，请咨询58383861。</div>
      </div>

    </Card>

  </div>
</template>
<script>
import AdminHome from './adminHome.vue'
import GysHome from './gysHome.vue'
export default {
  components: { AdminHome, GysHome },
  data() {
    return {
      isAdmin: null,
    }
  },
  created() {
    this.getIsAdmin()
  },
  methods: {
    async getIsAdmin() {
      // this.isAdmin=false
      //  let { data } = await this.$Ajax.get('/api/services/app/GetIndexService/GetCurrentRole')
      //     this.isAdmin=data.result.isGLY
    },
  },
}
</script>
